import './reviewBookInfo.css';
import CharCount from '../../../../../components/charCount/CharCount';
import { getFormattedDateReverse } from '../../../../../utils/date';
// import { UserLoginSecContext } from '../../../../../context/UserLoginSecContext';
// import { UserAuthContext } from '../../../../../context/UserAuthContext';
// import { useContext } from 'react';

export default function ReviewBookInfo({ userDetails, bookingData, setUserDetails, guest, setGuest }) {
    //  const { setLogButton } = useContext(UserLoginSecContext);
    // const { isAuthenticated } = useContext(UserAuthContext);
    const isCustomBooking = bookingData?.datesType === 'custom';
    const customStartDate = bookingData?.startDate ? bookingData?.startDate : null;

    const customEndDate = bookingData?.endDate ? bookingData?.endDate : null;

    // const totalAdults = bookingData?.customTrip?.rooms?.reduce((acc, room) => acc + room?.adults, 0);

    function handleUser(e, index) {
        setUserDetails((prevState) => {
            return prevState.map((obj, objIndex) => {
                return objIndex === index ? { ...obj, [e.target.name]: e.target.value } : obj;
            });
        });
    }
    return (
        <div className='reviewBoInfoDiv'>
            {Object.keys(bookingData).length !== 0 && isCustomBooking ? (
                <div className='reviewBoInfoDetail'>
                    <h3 className='reviewBoInfoPackName'>{bookingData.title}</h3>
                    <div className='reviewBoInfoTextDiv'>
                        <span className='reviewBoInfotext'>Start Date: {getFormattedDateReverse(customStartDate)}</span>
                        <span className='reviewBoInfoSpace'></span>
                        <span className='reviewBoInfotext'>End Date: {getFormattedDateReverse(customEndDate)}</span>
                        <span className='reviewBoInfoSpace'></span>
                        <span className='reviewBoInfotext'>Rooms: {bookingData?.customTrip?.rooms?.length}</span>
                        <span className='reviewBoInfotext'>Extra Beds: {Math.round(bookingData?.people / 3)}</span>
                        <span className='reviewBoInfoSpace'></span>
                        <span className='reviewBoInfotext'>
                            Total Adults: {bookingData?.slots || bookingData?.people}
                        </span>
                        {bookingData?.customTrip?.vehicleType?.filter((v) => v.vehicleCount > 0)?.length > 0 && (
                            <>
                                <span className='reviewBoInfoSpace'></span>
                                <span className='reviewBoInfotext'>
                                    Vehicle Type:{' '}
                                    {bookingData.customTrip.vehicleType
                                        .filter((v) => v.vehicleCount > 0)
                                        .map((v) => `${v.vehicleName}: ${v.vehicleCount}`)
                                        .join(', ')}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            ) : (
                <div className='reviewBoInfoDetail'>
                    <h3 className='reviewBoInfoPackName'>{bookingData.title}</h3>

                    <div className='reviewBoInfoTextDiv'>
                        <span className='reviewBoInfotext'>{getFormattedDateReverse(bookingData?.date)}</span>
                        <span className='reviewBoInfoSpace'></span>
                        <span className='reviewBoInfotext'>{bookingData.days + 'D/' + bookingData.nights + 'N'}</span>
                        <span className='reviewBoInfoSpace'></span>
                        <span className='reviewBoInfotext'>
                            {bookingData.people} {bookingData.people === 1 ? 'Ticket' : 'Tickets'}
                        </span>
                        <span className='reviewBoInfotext'>{bookingData.startCity}</span>
                        <span className='reviewBoInfoSpace'></span>
                        <span className='reviewBoInfotext'>{bookingData.pickupLocation}</span>
                        <span className='reviewBoInfoSpace'></span>
                        {bookingData?.room > 0 && (
                            <>
                                <span className='reviewBoInfotext'>Extra Room : {bookingData?.room}</span>
                                <span className='reviewBoInfoSpace'></span>
                            </>
                        )}

                        {bookingData.group === 'backpacking' ? (
                            <span className='reviewBoInfotext'>
                                {bookingData.transport === 'With transport'
                                    ? 'Transport included'
                                    : 'Transport not included'}
                            </span>
                        ) : (
                            <>
                                <span className='reviewBoInfotext'>Vehicle : {bookingData.vehicleType}</span>
                                <span className='reviewBoInfoSpace'></span>
                                <span className='reviewBoInfotext'>Model : {bookingData.vehicleModel}</span>
                            </>
                        )}
                    </div>
                </div>
            )}
            {/* {isAuthenticated.length === 0 && (
                <p className='reviewBoInfoNoteP'>
                    Note - If you are continuing as guest, The first user details will be used for communication for
                    this booking.
                </p>
            )} */}
            {/* {!guest && (
                <div className='reviewBoInfoBtnDivLog'>
                    <button
                        onClick={function () {
                            setLogButton(true);
                        }}
                        className='reviewBoInfoLoginBtn'
                        type='button'
                    >
                        Login
                    </button>
                    <div className='reviewBoInfoBtnGueDiv'>
                        <p>Or Continue as a</p>
                        <button type='button' className='reviewBoInfoGuestBtn grayBtn' onClick={() => setGuest(true)}>
                            Guest
                        </button>
                    </div>
                </div>
            )} */}
            {/* {guest && <p className='reviewBoInfoNoteP'>Continuing as guest.</p>} */}
            {
                <div>
                    {Array.apply(null, { length: bookingData.people }).map(function (_, peopleIndex) {
                        return (
                            <div key={peopleIndex} className='reviewBoInfoUserDiv'>
                                <div className='reviewBoInfoNameAge'>
                                    <div className='reviewBoInfoName'>
                                        <label className='reviewBoInfoLabel'>Name</label>
                                        <input
                                            value={userDetails[peopleIndex]?.name}
                                            name='name'
                                            onChange={(e) => handleUser(e, peopleIndex)}
                                            type='text'
                                            placeholder={`Person ${peopleIndex + 1} name`}
                                            className='reviewBoInfoInput'
                                        ></input>
                                        <CharCount
                                            string={
                                                userDetails[peopleIndex]?.name ? userDetails[peopleIndex]?.name : ''
                                            }
                                            min={3}
                                            limit={30}
                                        />
                                    </div>
                                    <div className='reviewBoInfoName'>
                                        <label className='reviewBoInfoLabel'>Age</label>
                                        <input
                                            value={userDetails[peopleIndex]?.age}
                                            name='age'
                                            onChange={(e) => handleUser(e, peopleIndex)}
                                            type='number'
                                            placeholder="Person's age"
                                            className='reviewBoInfoInput'
                                        ></input>
                                    </div>
                                </div>
                                <div className='reviewBoInfoNameAge'>
                                    <div className='reviewBoInfoName'>
                                        <label className='reviewBoInfoLabel'>Gender</label>
                                        <select
                                            value={userDetails[peopleIndex]?.sex}
                                            name='sex'
                                            onChange={(e) => handleUser(e, peopleIndex)}
                                            className='reviewBoInfoInput'
                                        >
                                            <option value='Select'>Select</option>
                                            <option value='Male'>Male</option>
                                            <option value='Female'>Female</option>
                                            <option value='Others'>Others</option>
                                        </select>
                                    </div>
                                    {peopleIndex === 0 ? (
                                        <div className='reviewBoInfoName'>
                                            <label className='reviewBoInfoLabel'>Email</label>
                                            <input
                                                value={userDetails[peopleIndex]?.emailId}
                                                name='emailId'
                                                onChange={(e) => handleUser(e, peopleIndex)}
                                                type='text'
                                                placeholder={'Email Id of person ' + (peopleIndex + 1)}
                                                className='reviewBoInfoInput'
                                            ></input>
                                        </div>
                                    ) : (
                                        <div className='reviewBoInfoName'>
                                            <label className='reviewBoInfoLabel'>Phone Number (WhatsApp)</label>
                                            <input
                                                value={userDetails[peopleIndex]?.phoneNumber}
                                                name='phoneNumber'
                                                onChange={(e) => {
                                                    let value = e.target.value.replace(/\D/g, ''); // remove non-digit characters
                                                    value = value.replace(/^0+/, '');
                                                    if (value.length <= 10) {
                                                        handleUser(
                                                            { target: { name: 'phoneNumber', value } },
                                                            peopleIndex
                                                        );
                                                    }
                                                }}
                                                type='number'
                                                placeholder='Mobile Number'
                                                className='reviewBoInfoInput'
                                            ></input>
                                        </div>
                                    )}
                                </div>
                                <div className='reviewBoInfoNameAge'>
                                    {/* <div className='reviewBoInfoName'>
                                        <label className='reviewBoInfoLabel'>Country code</label>
                                        <select
                                            value={userDetails[peopleIndex].countryCode}
                                            name='countryCode'
                                            onChange={(e) => handleUser(e, peopleIndex)}
                                            className='reviewBoInfoInput'
                                        >
                                            <option value='+91'>+91</option>
                                        </select>
                                    </div> */}
                                    {peopleIndex === 0 && (
                                        <div className='reviewBoInfoName'>
                                            <label className='reviewBoInfoLabel'>Phone Number (WhatsApp)</label>
                                            <input
                                                value={userDetails[peopleIndex]?.phoneNumber || ''}
                                                name='phoneNumber'
                                                onChange={(e) => {
                                                    let value = e.target.value.replace(/\D/g, ''); // remove non-digit characters
                                                    value = value.replace(/^0+/, '');
                                                    if (value.length <= 10) {
                                                        handleUser(
                                                            { target: { name: 'phoneNumber', value } },
                                                            peopleIndex
                                                        );
                                                    }
                                                }}
                                                type='tel'
                                                inputMode='numeric'
                                                placeholder='Mobile Number'
                                                className='reviewBoInfoInput'
                                                maxLength={10}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            }
        </div>
    );
}
